import apiClient from "./config";
import { CITY_COMPARISON_ENDPOINTS } from "./endpoints";

const cityComparisonService = {
  share: (data) => {
    return apiClient.post(CITY_COMPARISON_ENDPOINTS.SHARE, data);
  },
  sharedComparison: (token) => {
    return apiClient.get(
      `${CITY_COMPARISON_ENDPOINTS.SHARED_COMPARISON}/${token}`,
    );
  },
  sharedComparisonPDF: (data) => {
    return apiClient.post(
      CITY_COMPARISON_ENDPOINTS.SHARED_COMPARISON_PDF,
      data,
      {
        responseType: "blob", // <-- Add this!
      },
    );
  },
  ComparisonTrack: (data) => {
    return apiClient.post(CITY_COMPARISON_ENDPOINTS.COMPARISON_TRACK, data);
  },
  sessionId: (data) => {
    return apiClient.post(CITY_COMPARISON_ENDPOINTS.SESSION_ID, data);
  },
  exportAnalytics: (data) => {
    return apiClient.post(CITY_COMPARISON_ENDPOINTS.EXPORT_ANALYTICS, data);
  },
  popularWorkLocations: () => {
    return apiClient.get(CITY_COMPARISON_ENDPOINTS.POPULAR_WORK_LOCATIONS, {
      params: {
        state_limit: 6,
        city_limit: 6,
      },
    });
  },
};

export default cityComparisonService;
